import React from "react"
import BackgroundImage from "gatsby-background-image"
import { StaticQuery, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import Layout from "../../../components/layout"
import style from "./index.module.css"
import AndvicHeader from "../../../components/andvic-header"
import BurgerMenu from "../../../components/burger-menu"

import Carousel, { Modal, ModalGateway, ViewType } from "react-images"
import SEO from "../../../components/seo"

export interface IAppProps {
  data: any
}

export interface IAppState {
  modalIsOpen: boolean
  selectedIndex?: number
}

class Gallery extends React.Component<IAppProps, IAppState> {
  constructor(props: IAppProps) {
    super(props)

    this.state = {
      modalIsOpen: false,
      selectedIndex: 0,
    }
  }

  toggleLightbox = (selectedIndex: number = 0) => {
    this.setState(state => ({
      modalIsOpen: !state.modalIsOpen,
      selectedIndex,
    }))
  }

  public render() {
    const { data } = this.props

    const images = data.galleryImages.edges.map((x: any) => ({
      source: x.node.childImageSharp.fluid.src,
      originalName: x.node.childImageSharp.fluid.originalName,
    }))

    const sortedImage = [...images].sort((a: any, b: any) =>
      a.originalName > b.originalName
        ? 1
        : b.originalName > a.originalName
        ? -1
        : 0
    )

    console.log("yolllloo", sortedImage)

    const { modalIsOpen, selectedIndex } = this.state

    return (
      <>
        <ModalGateway>
          {modalIsOpen ? (
            <Modal
              closeOnBackdropClick={true}
              closeOnEsc={true}
              onClose={_e => {
                this.toggleLightbox(0)
              }}
            >
              <Carousel
                currentIndex={selectedIndex}
                styles={{
                  footerCaption: (base, state) => ({
                    ...base,
                    display: "none",
                  }),
                  view: base => ({
                    ...base,
                    "& > img": {
                      margin: "auto",
                    },
                  }),
                }}
                views={sortedImage}
              />
            </Modal>
          ) : null}
        </ModalGateway>
        <div onClick={_e => this.toggleLightbox(0)}>
          <Img fluid={data.lounge.childImageSharp.fluid} />
        </div>
        <div onClick={_e => this.toggleLightbox(2)}>
          <Img fluid={data.outdoor.childImageSharp.fluid} />
        </div>
        <div onClick={_e => this.toggleLightbox(2)}>
          <Img fluid={data.lounge2.childImageSharp.fluid} />
        </div>
        <div onClick={_e => this.toggleLightbox(3)}>
          <Img fluid={data.bathroom.childImageSharp.fluid} />
        </div>
      </>
    )
  }
}

const BackgroundSection = ({
  className,
  data,
  header,
}: {
  className: any
  data: any
  header: any
}) => {
  const imageData = data.desktop.childImageSharp.fluid
  return (
    <>
      <BackgroundImage Tag="section" className={className} fluid={imageData}>
        <AndvicHeader></AndvicHeader>

        <h1 className={style.pageHeader}>
          <span>{header}</span>
        </h1>
      </BackgroundImage>
    </>
  )
}

export default function IndexPage(): JSX.Element {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "northern-beaches/60610-lores.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
            originalName
          }
        }
      }

      lounge: file(name: { eq: "1-lounge" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      outdoor: file(name: { eq: "2-outdoor" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      lounge2: file(name: { eq: "3-lounge2" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      bathroom: file(name: { eq: "4-bathroom" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      galleryImages: allFile(
        filter: { relativeDirectory: { eq: "northern-beaches/gallery" } }
      ) {
        edges {
          node {
            relativePath
            relativeDirectory
            dir
            childImageSharp {
              fluid(quality: 80, maxWidth: 1920) {
                ...GatsbyImageSharpFluid
                originalName
              }
            }
          }
        }
      }

      portfolioOne: file(
        relativePath: { eq: "northern-beaches/60583-lores.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="Northern Beaches - Portfolio" />
      <BurgerMenu></BurgerMenu>

      <BackgroundSection
        data={data}
        className={style.header}
        header="Northern Beaches"
      ></BackgroundSection>

      <div className={style.portfolioMain}>
        <div>
          <h2 className={style.portfolioSubheader}>
            Spacious & Family Friendly
          </h2>
          <p>
            Luxury family home in the Northern Beaches with 5 oversized and
            light filled bedrooms, in-built wardrobes and underfloor heating to
            bathrooms. Designed with a central atrium is an architectural
            highlight where volumes of light fill the open plan living space
            through a soaring 5metre high wall of glass.
          </p>
          <p>Modern and eco-living for a large family with</p>
          <ul className={style.bulletList}>
            <li>
              Kitchen and dining meld easily with the tiled north facing outdoor
              alfresco patio with in-built BBQ and seating
            </li>
            <li>
              North facing tiled plunge pool straight from the entertaining sun
              deck
            </li>
            <li>
              Warm natural timber finishes with wide American Oak panel
              flooring, fabulous whitewashed Birch plywood ceiling and Walsh
              Pine feature wall
            </li>
          </ul>
        </div>
        <div className={style.home2}>
          <div>
            <Img fluid={data.portfolioOne.childImageSharp.fluid} />
          </div>
        </div>
      </div>
      <div className={style.portfolioGallery}>
        <Gallery data={data} />
      </div>
    </Layout>
  )
}
